import {Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {Dialog} from 'primeng/dialog';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogComponent {

  @Input()
  dialogClass: string | string[] | Set<string> | {
    [klass: string]: any;
  } | undefined;
  @Output()
  visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild(Dialog) dialog: { center: () => void; } | undefined;
  private _visible: boolean = false;

  get visible(): boolean {
    return this._visible;
  }

  @Input()
  set visible(visible: boolean) {
    this._visible = visible;
    this.visibleChange.emit(visible);
  }

  private _break = false;

  public get breakReason(): boolean {
    return this._break;
  }

  @Input()
  public set breakReason(breakReason: boolean) {
    if (this._break !== breakReason) {
      this._break = breakReason;
    }
  }

  public center() {
    // @ts-ignore
    this.dialog.center();
  }

}
